import _ from 'lodash'

export interface PathMap {
    // path before plugin and path after
    [originalPath: string]: string
}

export const unsetAndCleanEmptyObjects = (obj: any, path: string) => {
    _.unset(obj, path)
    const pathToParentObj = path.split('.').slice(0, -1)
    while (pathToParentObj.length > 0 && _.isEmpty(_.get(obj, pathToParentObj))) {
        _.unset(obj, pathToParentObj)
        pathToParentObj.pop()
    }
}

export const moveFields = (component: any, mapper: PathMap) => {
    _.forEach(mapper, (destPath, originalPath) => {
        const value = _.get(component, originalPath)
        if (!_.isNil(value)) {
            _.set(component, destPath, value)
            unsetAndCleanEmptyObjects(component, originalPath)
        }
    })
}
export const copyFields = (component: any, mapper: PathMap) => {
    _.forEach(mapper, (destPath, originalPath) => {
        const value = _.get(component, originalPath)
        if (!_.isNil(value)) {
            _.set(component, destPath, value)
        }
    })
}
